import StaffHTTPService from 'services/HTTPService/staff/StaffHTTPService';
import { useAppMutation } from 'services/reactQuery/useAppMutation';
import { appPaths } from 'consts/paths/paths';
import { MealTypeAddEditForm } from 'components/templates';
import { useSimpleNotification } from 'hooks/useSimpleNotification/useSimpleNotification';
import { MealTypesFormFields } from 'types';
import { parseMealTypesFormFieldsIntoAddUpdateMealTypeDTO } from 'utils/parsers/mealTypes/parseMealTypesFormFieldsIntoAddUpdateMealTypeDTO';
import { settingsTexts } from 'consts/text';
import { useNavigateWithState } from 'hooks/useNavigateWithState/useNavigateWithState';
import { mealTypeAddEditErrorParser } from 'utils/errorHandlers/settings/mealTypeAddEditErrorParser';

export const MealTypesAddPage = () => {
    const { statefulNavigate } = useNavigateWithState();
    const { displaySuccess } = useSimpleNotification();

    const onSuccess = () => {
        displaySuccess(settingsTexts.mealTypes.successNotifications.mealTypeAdded);
        statefulNavigate(appPaths.app.settings.diets.mealTypes.base, { replace: true });
    };

    const { mutate, error, isLoading } = useAppMutation(StaffHTTPService.mealTypes.addMealType, {
        key: ['ADD_MEAL_TYPE'],
        onSuccess,
        invalidateQueryKeys: [['MEAL_TYPES']],
    });

    const onFinish = (mealTypeData: MealTypesFormFields) => {
        mutate(parseMealTypesFormFieldsIntoAddUpdateMealTypeDTO(mealTypeData));
    };

    return (
        <MealTypeAddEditForm
            type="add"
            axiosError={error ? mealTypeAddEditErrorParser(error) : undefined}
            isLoading={isLoading}
            onFinish={onFinish}
        />
    );
};
